import { AxiosResponse } from 'axios';
import instance from '../../api/instance';
import { Device } from './devices.types';
import { CompanyDevice } from '../phy_devices/types';
import { createCompanyDevice } from './devices.state';

export type GetCompanyDevices = (params: { companyId: string }) => Promise<AxiosResponse<Device[]>>;

export const getCompanyDevices: GetCompanyDevices = async ({ companyId }) => {
  return instance.get(`companies/${companyId}/devices`).catch(e => e.response as never);
};

export interface RemoveCompanyDeviceResponse {
  createdAt: string;
  updatedAt: string;
  id: string;
}

export type RemoveCompanyDevice = (params: {
  companyId: string;
  deviceId: string;
}) => Promise<AxiosResponse<RemoveCompanyDeviceResponse>>;

export const removeCompanyDevice: RemoveCompanyDevice = async ({ companyId, deviceId }) => {
  return instance.delete(`companies/${companyId}/devices/${deviceId}`).catch(e => e.response as never);
};

export type AddDevice = (params: { companyId: string; deviceId: string }) => Promise<AxiosResponse<Device>>;

export const createCompanyDeviceAPI: AddDevice = async ({ companyId, deviceId }) => {
  return instance.post<Device>(`companies/${companyId}/devices`, { deviceId }).catch(e => e.response as never);
};
